var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("contact-table", {
        ref: "table",
        attrs: { url: _vm.indexUrl },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _vm.canCreate
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-purple",
                        on: { click: _vm.addContact },
                      },
                      [_c("i", { staticClass: "far fa-file" })]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("dialog-form-wrapper"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }